import { Component, OnInit } from "@angular/core"
import TemplateString from "./film-cards.component.html"

@Component({
  selector: "app-film-cards",
  template: TemplateString,
  inputs: ["film", "teenScreen"],
})
export class FilmCardsComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
